define('gumbo-js-client-lib/forms/gameData/DateTimeForm',['require','exports','module','jquery','./DateTeamForm'],function(require, exports, module) {
	var $ = require("jquery"),
		dateTeamFormat = require("./DateTeamForm");

	return {
		ampm: null,
		day: null,
		dayNight: null,
		firstPitchET: null,
		originalDate: null,
		resumeDate: null,
		time: null,
		timeGMT: null,
		timeDate: null,
		timezone: null,
		away: $.extend({}, dateTeamFormat),
		home: $.extend({}, dateTeamFormat)
	};
});
